<template>
    <div class="data-title">
        <i class="title-icon el-icon-caret-right"></i>
        {{title}}
    </div>
</template>
<script>
export default {
    name: 'DataTitle',
    props: {
        title: {
            type: String,
            required: true,
            default: () => '数据标题',
        },
    },
};
</script>
<style lang="scss" scoped>
.data-title {
    height: 30px;
    line-height: 30px;
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: bold;
    display: flex; // 合并display类

    .title-icon {
        display: inline-block;
        margin: 7px 5px 0 -5px;
        color: #34C6D0;
    }
}
</style>
